import React, { CSSProperties, FC } from 'react';
import Loader from 'react-loader-spinner';

import colors from '../../assets/colors';
import Styled from './styles';
import { fontSize, typography } from '../../assets/themes';

type AppButtonProps = {
	image?: JSX.Element | null;
	imageLeft?: boolean;
	imageRight?: JSX.Element | null;
	size?: string;
	color?: keyof typeof colors;
	title?: string;
	titleColor?: keyof typeof colors;
	type?: keyof typeof typography;
	isBorder?: boolean;
	borderColor?: keyof typeof colors;
	borderWidth?: number;
	isDisabled?: boolean;
	isLoading?: boolean;
	isRequest?: boolean;
	loaderColor?: keyof typeof colors;
	fontS?: keyof typeof fontSize;
	style?: CSSProperties;
	btnType?: 'default' | 'options';
	hover?: keyof typeof colors;
	hoverText?: keyof typeof colors;
	callBack?(): void;
};

const loaderSize = 30;

const AppButton: FC<AppButtonProps> = ({
	children,
	image = null,
	imageLeft = true,
	imageRight,
	size = 'L',
	color = 'black',
	title = 'Title',
	titleColor = 'white',
	type = 'primary',
	isBorder,
	borderColor = 'btnTextGrey',
	borderWidth = 1,
	isDisabled,
	isLoading,
	isRequest,
	loaderColor = 'white',
	fontS = 'medium',
	style = {},
	btnType = 'default',
	hover,
	hoverText = 'white',
	callBack = () => null,
}) => {
	if (btnType === 'options') {
		return (
			<Styled.Button
				hover={hover}
				hoverText={hoverText}
				color={titleColor}
				backgroundColor={color}
				size={size}
				isBorder={isBorder}
				borderColor={borderColor}
				borderWidth={borderWidth || 1}
				style={{ ...style }}
				onClick={callBack}
				disabled={isDisabled || isLoading}
			>
				{isLoading ? (
					<Loader
						type="TailSpin"
						color={colors[loaderColor]}
						height={loaderSize}
						width={loaderSize}
					/>
				) : (
					<Styled.Container
						{...(!imageRight
							? {}
							: {
									style: {
										width: '100%',
									},
							  })}
					>
						<Styled.Info>
							<div style={{ marginRight: 6 }}>{image}</div>
							<Styled.StyledButtonText
								type={'bold'}
								text={children ? '' : title}
								color={titleColor}
								size={fontS}
							>
								{children}
							</Styled.StyledButtonText>
						</Styled.Info>

						{imageRight}
					</Styled.Container>
				)}
			</Styled.Button>
		);
	}

	return (
		<Styled.Button
			hover={hover}
			color={titleColor}
			backgroundColor={color}
			size={size}
			isBorder={isBorder}
			borderColor={borderColor}
			borderWidth={borderWidth || 1}
			style={{ ...style }}
			onClick={callBack}
			disabled={isDisabled || isLoading}
		>
			{isLoading ? (
				<Loader
					type="TailSpin"
					color={colors[loaderColor]}
					height={loaderSize}
					width={loaderSize}
				/>
			) : (
				<Styled.Content>
					{imageLeft && image}
					<Styled.StyledButtonText
						type={type}
						text={children ? '' : title}
						color={titleColor}
						size={fontS}
					>
						{children}
					</Styled.StyledButtonText>
					{!imageLeft && image}
				</Styled.Content>
			)}
		</Styled.Button>
	);
};

export default AppButton;
